import { makeStyles } from '@material-ui/core';

const useSelectEntityStyles = makeStyles((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');

  return ({
    content: {
      paddingTop: '1rem',
      [mobileBreakpoint]: {
        padding: '16px 0px 16px 12px',
        marginBottom: '-80px'
      }
    },
    radioGroup: {
      paddingLeft: '0.8125rem',
      marginBottom: '1rem',
      [mobileBreakpoint]: {
        paddingLeft: 0
      }
    },
    subtitle: {
      fontWeight: 500,
      marginTop: '70px'
    },
    companyName: {
      fontFamily: 'var(--font-family-bold)',
      fontSize: 'var(--input-font-size)',
      color: 'var(--dark-grey)'
    },
    lastUpdated: {
      fontFamily: 'var(--font-family-base)',
      fontSize: 'var(--input-font-size)',
      color: 'var(--light-grey)'
    },
    formControl: {
      marginBottom: '1rem',
      '& .MuiFormControl-root': {
        display: 'flex',
        alignSelf: 'flex-start',
        paddingTop: '0.25rem'
      }
    },
    continueBtn: {
      background: '#007DB8 !important',
      borderRadius: '4px',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '22px',
      fontFamily: 'var(--font-family-bold)',
      textTransform: 'capitalize',
      color: 'var(--white) !important',
      marginTop: '-0.5rem',
      float: 'right',
      '&[disabled]': {
        color: 'var(--white) !important',
        backgroundColor: 'var(--disabled) !important'
      }
    }
  });
});

export default useSelectEntityStyles;
